// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/UseForm/UseForm.css */

.use-last-container{
    display: flex;
    width: 85%;
    margin: auto;
}

.use-form-container {
    overflow-y: auto;
    background-color: #f4f4f4;
    margin: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
    position: relative;
    height: 50vh;
    display: flex;
    flex-direction: column;
    flex: 0 0 80%;  
    width: 100%;
    margin: 0 auto;
}

.header-containerrr {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
}

.header-containerrr .list_form_headiii {
    flex: 1 1;
    text-align: center;
}

.list_form_headiii {
    color: #EF6F53;
    text-align: center;
    font-size: 1.25rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    cursor: default;
    text-transform: uppercase;
}

.use-form-container form {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    margin-bottom: 50px;
}

.form-fields-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: -0.25rem;
}

.label-inputt {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: calc(33.33% - 0.5rem);
    margin-bottom: 0.25rem;
    padding: 0.25rem;
}

.label-inputt select{
    font-size: 0.7rem;
    width: 50%; 
    background-color: white;
    color: #323232;
    border: 1px solid #b8c2cf;
    border-radius: 8px;
    text-align: center;
}

.use-form-container label {
    font-weight: bold;
    margin: 0.35rem;
    font-size: 0.85rem;
    color: #364C63;
    margin-right: 0.5rem;
    text-align: left;
    width: 35%; 
}

.use-form-container label span.required {
    color: #EF6F53;
}

.use-form-container input {
    flex: 1 1;
    padding: 0.3rem 0.4rem;
    border: 1px solid #b8c2cf;
    border-radius: 8px;
    font-size: 0.75rem;
    background: #ffffff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    color: #323232;
    width: 100%;
}

.use-form-container input:focus,
.label-inputt select:focus,
.label-inputt.comment .comet:focus {
    border-color: #EF6F53;
    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);
    outline: none;
}

.label-inputt.comment {
    width: 100%;
    margin-bottom: 0.25rem;
    display: flex;
    align-items: flex-start;
}

.label-inputt.comment label {
    font-weight: bold;
    margin: 0.35rem;
    font-size: 0.85rem;
    color: #364C63;
    margin-right: 0.5rem;
    text-align: left;
    width: 35%;
}

.label-inputt.comment .textarea-container {
    display: flex;
    margin-left: -5rem;
    width: 100%;
}

.label-inputt.comment .comet {
    width: 100%;
    resize: vertical;
    padding: 0.3rem 0.4rem;
    border: 1px solid #b8c2cf;
    border-radius: 8px;
    font-size: 0.75rem;
    background: #ffffff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    color: #323232;
}

.sbt-use-btn {
    background-color: #364C63;
    color: white;
    padding: 0.15rem;
    font-size: 0.8rem;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 10%;
    position: sticky;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: auto;
    font-weight: 600;
}

.sbt-use-btn:hover {
    background-color: blue;
}

.home-icon {
    width: 35px;
    height: 35px;
    margin-left: 1rem;
    transition: transform 0.2s ease;
    border-radius: 50%;
    border: 2px solid #364C63;  
    padding: 5px;
}

.home-icon:hover {
    transform: scale(1.1);
    border-color: #EF6F53;  
}

.add-field-btnnn {
  display: flex;
  background-color: #EF6F53;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  margin: auto;
  align-items:center ;
  justify-content: center;
  
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.add-field-btnnn:hover{
  background-color: #f8360b;
  transform: translateY(1px); 
}

.customer-info-header {
    background-color: #364C63;
    color: white;
    padding: 0.5rem;
    border-radius: 5px;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.customer-info-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
}

.customer-name {
    font-size: 1.1rem;
    font-weight: 500;
}

.customer-phone {
    font-size: 0.85rem;
    opacity: 0.9;
    position: relative;
    padding-left: 1rem;
}

.customer-phone:before {
    content: "•";
    position: absolute;
    left: 0;
    opacity: 0.9;
}

.edit-icon {
    cursor: pointer;
    font-size: 1rem !important;
    opacity: 0.9;
    transition: all 0.2s ease;
}

.edit-icon:hover,
.edit-icon.active {
    opacity: 0.9;
    color: #EF6F53;
}

/* Responsive styles */
@media screen and (max-width: 1200px) {
    .label-inputt {
        width: calc(50% - 0.5rem);
    }
}

@media screen and (max-width: 768px) {
    .label-inputt {
        width: 100%;
    }
}

@media only screen and (min-width: 901px) and (max-width: 1280px) {
    .use-form-container {
        height: 75vh;
        padding: 0.75rem;
    }

    .label-inputt {
        width: 45%;
        margin-bottom: 0.5rem;
    }

    .use-form-container label {
        font-size: 0.8rem;
        width: 40%;
    }

    .use-form-container input {
        font-size: 0.7rem;
        padding: 0.2rem;
    }

    .label-inputt select {
        font-size: 0.7rem;
        width: 55%;
    }

    .sbt-use-btn {
        width: 15%;
        font-size: 0.75rem;
        padding: 0.25rem;
        bottom: 15px;
    }

}

@media only screen and (min-width: 1281px) and (max-width: 1400px) {
    .use-form-container {
        height: 80vh;
        padding: 1rem;
    }

    .label-inputt {
        width: 32%;
        margin-bottom: 0.75rem;
    }

    .use-form-container label {
        font-size: 0.9rem;
        width: 35%;
    }

    .use-form-container input {
        font-size: 0.8rem;
        padding: 0.25rem;
    }

    .label-inputt select {
        font-size: 0.8rem;
        width: 50%;
    }

    .sbt-use-btn {
        width: 12%;
        font-size: 0.85rem;
        padding: 0.3rem;
        bottom: 20px;
    }

    .list_form_headiii {
        font-size: 1.3rem;
        margin-bottom: 1rem;
    }
}

@media (max-width: 1200px) {
    .form-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .form-grid {
        grid-template-columns: 1fr;
    }
}

/* Button styling */
.form-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;
}

.form-actions button {
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.form-actions button:hover {
    opacity: 0.9;
}

/* Primary button */
.btn-primary {
    background-color: #007bff;
    color: white;
    border: none;
}

/* Secondary button */
.btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
}

/* Danger button */
.btn-danger {
    background-color: #dc3545;
    color: white;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/UseForm/UseForm.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;IACI,aAAa;IACb,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wDAAwD;IACxD,cAAc;IACd,WAAW;AACf;;AAEA;;;IAGI,qBAAqB;IACrB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wDAAwD;IACxD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;;EAEvB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB","sourcesContent":["/* src/components/routes/Forms/UseForm/UseForm.css */\n\n.use-last-container{\n    display: flex;\n    width: 85%;\n    margin: auto;\n}\n\n.use-form-container {\n    overflow-y: auto;\n    background-color: #f4f4f4;\n    margin: auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n    position: relative;\n    height: 50vh;\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 80%;  \n    width: 100%;\n    margin: 0 auto;\n}\n\n.header-containerrr {\n    display: flex;\n    align-items: center;\n    position: relative;\n    width: 100%;\n}\n\n.header-containerrr .list_form_headiii {\n    flex: 1;\n    text-align: center;\n}\n\n.list_form_headiii {\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.25rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    cursor: default;\n    text-transform: uppercase;\n}\n\n.use-form-container form {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin-bottom: 50px;\n}\n\n.form-fields-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin: -0.25rem;\n}\n\n.label-inputt {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: calc(33.33% - 0.5rem);\n    margin-bottom: 0.25rem;\n    padding: 0.25rem;\n}\n\n.label-inputt select{\n    font-size: 0.7rem;\n    width: 50%; \n    background-color: white;\n    color: #323232;\n    border: 1px solid #b8c2cf;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.use-form-container label {\n    font-weight: bold;\n    margin: 0.35rem;\n    font-size: 0.85rem;\n    color: #364C63;\n    margin-right: 0.5rem;\n    text-align: left;\n    width: 35%; \n}\n\n.use-form-container label span.required {\n    color: #EF6F53;\n}\n\n.use-form-container input {\n    flex: 1;\n    padding: 0.3rem 0.4rem;\n    border: 1px solid #b8c2cf;\n    border-radius: 8px;\n    font-size: 0.75rem;\n    background: #ffffff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    color: #323232;\n    width: 100%;\n}\n\n.use-form-container input:focus,\n.label-inputt select:focus,\n.label-inputt.comment .comet:focus {\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);\n    outline: none;\n}\n\n.label-inputt.comment {\n    width: 100%;\n    margin-bottom: 0.25rem;\n    display: flex;\n    align-items: flex-start;\n}\n\n.label-inputt.comment label {\n    font-weight: bold;\n    margin: 0.35rem;\n    font-size: 0.85rem;\n    color: #364C63;\n    margin-right: 0.5rem;\n    text-align: left;\n    width: 35%;\n}\n\n.label-inputt.comment .textarea-container {\n    display: flex;\n    margin-left: -5rem;\n    width: 100%;\n}\n\n.label-inputt.comment .comet {\n    width: 100%;\n    resize: vertical;\n    padding: 0.3rem 0.4rem;\n    border: 1px solid #b8c2cf;\n    border-radius: 8px;\n    font-size: 0.75rem;\n    background: #ffffff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    color: #323232;\n}\n\n.sbt-use-btn {\n    background-color: #364C63;\n    color: white;\n    padding: 0.15rem;\n    font-size: 0.8rem;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 10%;\n    position: sticky;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-top: auto;\n    font-weight: 600;\n}\n\n.sbt-use-btn:hover {\n    background-color: blue;\n}\n\n.home-icon {\n    width: 35px;\n    height: 35px;\n    margin-left: 1rem;\n    transition: transform 0.2s ease;\n    border-radius: 50%;\n    border: 2px solid #364C63;  \n    padding: 5px;\n}\n\n.home-icon:hover {\n    transform: scale(1.1);\n    border-color: #EF6F53;  \n}\n\n.add-field-btnnn {\n  display: flex;\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.85rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  margin: auto;\n  align-items:center ;\n  justify-content: center;\n  \n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.add-field-btnnn:hover{\n  background-color: #f8360b;\n  transform: translateY(1px); \n}\n\n.customer-info-header {\n    background-color: #364C63;\n    color: white;\n    padding: 0.5rem;\n    border-radius: 5px;\n    margin-bottom: 1rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.customer-info-section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n}\n\n.customer-name {\n    font-size: 1.1rem;\n    font-weight: 500;\n}\n\n.customer-phone {\n    font-size: 0.85rem;\n    opacity: 0.9;\n    position: relative;\n    padding-left: 1rem;\n}\n\n.customer-phone:before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    opacity: 0.9;\n}\n\n.edit-icon {\n    cursor: pointer;\n    font-size: 1rem !important;\n    opacity: 0.9;\n    transition: all 0.2s ease;\n}\n\n.edit-icon:hover,\n.edit-icon.active {\n    opacity: 0.9;\n    color: #EF6F53;\n}\n\n/* Responsive styles */\n@media screen and (max-width: 1200px) {\n    .label-inputt {\n        width: calc(50% - 0.5rem);\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .label-inputt {\n        width: 100%;\n    }\n}\n\n@media only screen and (min-width: 901px) and (max-width: 1280px) {\n    .use-form-container {\n        height: 75vh;\n        padding: 0.75rem;\n    }\n\n    .label-inputt {\n        width: 45%;\n        margin-bottom: 0.5rem;\n    }\n\n    .use-form-container label {\n        font-size: 0.8rem;\n        width: 40%;\n    }\n\n    .use-form-container input {\n        font-size: 0.7rem;\n        padding: 0.2rem;\n    }\n\n    .label-inputt select {\n        font-size: 0.7rem;\n        width: 55%;\n    }\n\n    .sbt-use-btn {\n        width: 15%;\n        font-size: 0.75rem;\n        padding: 0.25rem;\n        bottom: 15px;\n    }\n\n}\n\n@media only screen and (min-width: 1281px) and (max-width: 1400px) {\n    .use-form-container {\n        height: 80vh;\n        padding: 1rem;\n    }\n\n    .label-inputt {\n        width: 32%;\n        margin-bottom: 0.75rem;\n    }\n\n    .use-form-container label {\n        font-size: 0.9rem;\n        width: 35%;\n    }\n\n    .use-form-container input {\n        font-size: 0.8rem;\n        padding: 0.25rem;\n    }\n\n    .label-inputt select {\n        font-size: 0.8rem;\n        width: 50%;\n    }\n\n    .sbt-use-btn {\n        width: 12%;\n        font-size: 0.85rem;\n        padding: 0.3rem;\n        bottom: 20px;\n    }\n\n    .list_form_headiii {\n        font-size: 1.3rem;\n        margin-bottom: 1rem;\n    }\n}\n\n@media (max-width: 1200px) {\n    .form-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .form-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Button styling */\n.form-actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.form-actions button {\n    padding: 8px 16px;\n    border-radius: 4px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.form-actions button:hover {\n    opacity: 0.9;\n}\n\n/* Primary button */\n.btn-primary {\n    background-color: #007bff;\n    color: white;\n    border: none;\n}\n\n/* Secondary button */\n.btn-secondary {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n}\n\n/* Danger button */\n.btn-danger {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
